import { Injectable } from '@angular/core';
import { CloudServiceEnum } from '../cloud-storage/enums/cloud-service.enum';
import { WolandOneDriveAuthService } from './one-drive.auth.service';
import { WolandGoogleDriveAuthService } from './google-drive.auth.service';

@Injectable({
  providedIn: 'root'
})
export class CloudConnectionService {
  private _examName = '';
  private _subject = '';

  get examName(): string {
    return this._examName;
  }

  set examName(value: string) {
    this._examName = value;
  }

  get subject(): string {
    return this._subject;
  }

  set subject(value: string) {
    this._subject = value;
  }

  constructor(
    private readonly onedrive: WolandOneDriveAuthService,
    private readonly googleDrive: WolandGoogleDriveAuthService
  ) { }

  isCloudConnected(cloud: CloudServiceEnum): boolean {
    switch (cloud) {
      case CloudServiceEnum.OneDrive:
        return this.onedrive.isConnected();
        case CloudServiceEnum.GoogleDrive:
        return this.googleDrive.isConnected();
      default:
        return false;
    }
  }

  async connectCloud(cloud: CloudServiceEnum) {
    try{
    switch (cloud) {
      case CloudServiceEnum.OneDrive:
        return await this.onedrive.authorize();
      case CloudServiceEnum.GoogleDrive:
        return await this.googleDrive.authorize();
      }
    }
    catch(error){
      console.log(error);
    }
  }

  async requestToken(code: string, cloud: string) {
    switch (cloud) {
      case CloudServiceEnum.OneDrive:
        return await this.onedrive.sendAutorizationCodetoServer(code, cloud);
      case CloudServiceEnum.GoogleDrive:
        return await this.googleDrive.sendAutorizationCodetoServer(code, cloud);
    }
  }

  async disconnectCloud(cloud: CloudServiceEnum) {
    console.log('disconnect cloud: ', cloud);
    switch (cloud) {
      case CloudServiceEnum.OneDrive:
        await this.onedrive.unAttachDrive();
        break;
      case CloudServiceEnum.GoogleDrive:
        await this.googleDrive.unAttachDrive();
        break;
    }
  }

  async getDisplayName(): Promise<string | null> {
    try {
      if (this.isCloudConnected(CloudServiceEnum.OneDrive)) {
        return await this.onedrive.getDisplayName();
      } else if (this.isCloudConnected(CloudServiceEnum.GoogleDrive)) {
        return await this.googleDrive.getDisplayName();
      }
    } catch (error) {
      console.error('get display name error: ', error);
    }
    return null;
  }

  clearDriveInfo(cloud: CloudServiceEnum): void {
    switch (cloud) {
      case CloudServiceEnum.OneDrive:
        this.onedrive.logout();
        break;
      case CloudServiceEnum.GoogleDrive:
        this.googleDrive.logout();
        break;
    }
  }
}
